<template>
    <div>
        <p class="head">视频投稿规范和要求</p>
        <p class="title">1. 目前有两种渠道实现视频上传</p>
        <div class="content">
            <p class="text">唯舞网页版创作中心——可上传不超500M的本地视频和对作品进行管理</p>
            <p class="text">唯舞APP——可以上传不超过10min的本地视频</p>
        </div>

        <p class="title">2. 本地上传文件格式要求</p>
        <div class="content">
            <p class="text">网页版创作中心上传大小不超过500M，手机端上传不超过5分钟</p>
            <p class="text">视频不能短于5秒</p>
            <p class="text">分辨率最大支持为1920x1080</p>
            <p class="text">网页版和投稿工具支持绝大多数的主流的视频文件格式，包括RMVB，WMV，ASF，AVI，3GP，MKV，MP4，MOV，MPG，MPEG，MPE，FLV，F4V，M4V，QT，RM，WEBM</p>
            <p class="text">IOS手机端支持视频文件格式，包括MP4，M4V；Android手机端支持视频文件格式，包括MKV，MP4，3GP，OGG，WEBM</p>
        </div>


        <p class="title">3. 以下视频内容不能上传</p>
        <div class="content">
            <p class="text">带有反动、色情、宗教、政治等其他违反国家相关法律内容的</p>
            <p class="text">带有主观恶意的诋毁、中伤、谩骂等侮辱性言论的</p>
            <p class="text">带有可能造成观看者身体不适、或其他临床症状的</p>
            <p class="text">其他涉及违反有关部门、条例规定要求的</p>
            <p class="text">具有较大争议性的</p>
        </div>


        <p class="title">4. 填写视频基本信息要求</p>
        <div class="content">
            <p class="text">标题——必填，不超过50个字符（1个汉字，标点和英文都算是1个字符）； 标题描述要符合视频内容，不要标题党，尽量使用中文标题</p>
            <p class="text">封面——选择内容清楚的视频截帧</p>
            <p class="text">分类——必选，最多选择3个分类。建议选择正确分类，选择正确分类将有机会让视频获得更多曝光机会</p>
            <p class="text">描述——选填，最长不超过250个字符</p>
        </div>
        <p class="title">5. 关于重复投稿</p>
        <div class="content">
            <p class="text">请勿重复投稿，系统会定期清理重复内容。</p>
        </div>


        <p class="title">6. 关于视频被退回</p>
        <div class="content">
            <p class="text">系统和审核人员会将不符合规范的视频进行退回锁定，被退回后视频将从线上移除。 如果对退回结果有疑问，请联系用户反馈群内的管理人员</p>
        </div>

        <p class="title">7. 为什么投稿会“上传失败”，而且重新上传时仍然失败？</p>
        <div class="content">
            <p class="text">网络的稳定性或浏览器限制会影响上传，建议在网络状况良好的情况下使用最新版Chrome浏览器进行上传。</p>
        </div>

        <p class="title">8. 关于唯舞视频相关任何问题，请联系用户反馈群内的管理人员咨询反馈</p>
    </div>
</template>

<script>
    export default {
        name: "UploadNorm"
    }
</script>

<style scoped>
    .head {
        font-size: 18px;
        font-weight: normal;
        border-bottom: 1px solid #969696;
        padding: 10px 0;
        margin-top: 0;
    }

    .title {
        color: #f1f1f1;
        font-size: 16px;
        margin: 20px 0 10px;
    }

    .content {
        padding: 0 15px;
        color: #969696;
        margin: 15px 0 45px;
    }

    .text {
        margin: 15px 0;
    }
</style>


// WEBPACK FOOTER //
// src/views/user/UploadNorm.vue